class PromoCode extends HTMLElement {
    constructor() {
      super();
      const urlCTA = this.querySelector('#promotion_code_cta');
      urlCTA.addEventListener('click', (event) => {
        event.preventDefault();
        let promo_code = document.querySelector('#promotion_code').value;
        const variants = this.getVariantsData();
        let itemsToString = "";
        for (var i = 0; i < variants.length; i++) {
            console.log(variants[i]);
            itemsToString += variants[i].variant_id + ":" + variants[i].quantity + ",";
        }
        if(itemsToString.length > 1){
          itemsToString = itemsToString.substring(0, itemsToString.length - 1);
        }
        let url_with_promo = `/cart/${itemsToString}?discount=${promo_code}`;
        window.location = url_with_promo;
      });
    }
    getVariantsData() {
        this.variantsData = this.variantsData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
        return this.variantsData;
    }
  }
  
  customElements.define('promo-code', PromoCode);
  
  